'use strict';

exports.__esModule = true;
exports.quiqeeWeeks = quiqeeWeeks;

var _fleetClient = require('../network/fleet-client');

var _fleetClient2 = _interopRequireDefault(_fleetClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  QUIQEE_WEEK: '/quiqee_weeks'
};

var fleet = {
  quiqeeWeeks: quiqeeWeeks
};

exports.default = fleet;
function quiqeeWeeks(payload) {
  return _fleetClient2.default.get({ route: API.QUIQEE_WEEK + '/' + payload.quiqeeId });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/profile/quiqee.js
// module id = 1193
// module chunks = 0